/*
 * Free shipping progress bar + smart add-on upsells
 * Reads config from #FSBConfig (rendered by the 'free-shipping-config' section).
 * Re-renders on the theme's native cart events (cart:updated, ajaxProduct:added).
 * Theme: Impulse (Archetype Themes).
 */
(function () {
  'use strict';
  if (window.__fsbInit) return;
  window.__fsbInit = true;

  function getConfig() {
    var el = document.getElementById('FSBConfig');
    if (!el) return null;
    try { return JSON.parse((el.textContent || '').trim()); } catch (e) { return null; }
  }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function getCart() {
    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      return theme.cart.getCart();
    }
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Cheapest add-ons that close the gap; if none can, the highest-value available ones.
  function pickSuggestions(products, gap, max, cartProductIds) {
    var avail = (products || []).filter(function (p) {
      return p && p.available && cartProductIds.indexOf(p.pid) === -1;
    });
    var closers = avail.filter(function (p) { return p.price >= gap; })
      .sort(function (a, b) { return a.price - b.price; });
    var chosen = closers.length
      ? closers
      : avail.slice().sort(function (a, b) { return b.price - a.price; });
    return chosen.slice(0, max);
  }

  function renderUpsell(root, items) {
    var wrap = root.querySelector('[data-fsb-upsell]');
    if (!wrap) return;
    if (!items.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    wrap.innerHTML = items.map(function (p) {
      var img = p.image
        ? '<img class="fsb__upsell-img" src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="40" height="40">'
        : '<span class="fsb__upsell-img"></span>';
      return '<div class="fsb__upsell-item">' + img +
        '<span class="fsb__upsell-info">' +
          '<span class="fsb__upsell-title">' + escapeHtml(p.title) + '</span>' +
          '<span class="fsb__upsell-price">' + formatMoney(p.price) + '</span>' +
        '</span>' +
        '<button type="button" class="fsb__upsell-add" data-fsb-add="' + p.id + '" aria-label="Add ' + escapeHtml(p.title) + '">+ Add</button>' +
      '</div>';
    }).join('');
    wrap.hidden = false;
  }

  function render(root, cart, cfg) {
    var threshold = cfg.threshold || 7000;
    var max = cfg.max || 2;
    var total = cart ? cart.total_price : 0;
    var count = cart ? cart.item_count : 0;
    var gap = threshold - total;
    var pct = threshold > 0 ? Math.max(0, Math.min(100, Math.round((total / threshold) * 100))) : 0;

    root.hidden = false;
    var fill = root.querySelector('[data-fsb-fill]');
    if (fill) fill.style.width = pct + '%';
    var track = root.querySelector('.fsb__track');
    if (track) { track.setAttribute('aria-valuemax', threshold); track.setAttribute('aria-valuenow', total); }

    root.classList.remove('fsb--state-empty', 'fsb--state-progress', 'fsb--state-unlocked');

    var msg;
    if (count === 0) {
      root.classList.add('fsb--state-empty');
      msg = (cfg.msgEmpty || '').replace('[threshold]', formatMoney(threshold));
      renderUpsell(root, []);
    } else if (gap > 0) {
      root.classList.add('fsb--state-progress');
      msg = (cfg.msgProgress || '').replace('[amount]', formatMoney(gap));
      var ids = (cart.items || []).map(function (i) { return i.product_id; });
      renderUpsell(root, pickSuggestions(cfg.products, gap, max, ids));
    } else {
      root.classList.add('fsb--state-unlocked');
      msg = cfg.msgUnlocked || '';
      renderUpsell(root, []);
    }
    var text = root.querySelector('[data-fsb-text]');
    if (text) text.textContent = msg;
  }

  function renderAll(cart) {
    var cfg = getConfig();
    var bars = document.querySelectorAll('[data-fsb]');
    if (!cfg || cfg.enable === false) {
      bars.forEach(function (b) { b.hidden = true; });
      return;
    }
    bars.forEach(function (b) { render(b, cart, cfg); });
  }

  function refresh() { return getCart().then(renderAll).catch(function () {}); }

  // One-tap add-to-cart for an upsell
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fsb-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var id = parseInt(btn.getAttribute('data-fsb-add'), 10);
    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        refresh();
      })
      .catch(function () {})
      .then(function () { btn.classList.remove('is-loading'); });
  });

  // Resync on the theme's cart events
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) { renderAll(e.detail.cart); } else { refresh(); }
  });
  document.addEventListener('ajaxProduct:added', function () { refresh(); });
  document.addEventListener('shopify:section:load', function () { refresh(); });

  function init() { refresh(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
